/**
 * @module mapbs.components.citymodel3d.citymodelpanel
 */
import angular from 'angular';
import * as olProj from 'ol/proj.js';
import mapbsCitymodel3dbutton from 'mapbs/components/citymodel3d/citymodel3dbutton/citymodel3dbutton';
import mapbsCitymodel3dService from 'mapbs/components/citymodel3d/citymodel3dservice/citymodel3dservice';
import './citymodel3d.scss';

const moduleCitymodelpanel = angular.module('mapbsCityModelPanel', [
    mapbsCitymodel3dbutton.name,
    mapbsCitymodel3dService.name,
]);

moduleCitymodelpanel.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/citymodel3d', require('./citymodelpanel.html'));
    }
);

/** @type {!angular.Component} */
const Citymodel3dComponent = {
    controller: 'MapbsCityModelController as ctrl',
    templateUrl: 'mapbs/citymodel3d',
    bindings: {
        'map': '<',
        'active': '<',
        'scaleValues': '<',
        'mobile': '<',
    },
};

moduleCitymodelpanel.component('mapbsCityModelPanel', Citymodel3dComponent);

class CityModelController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.auto.IInjectorService} $injector Main injector.
   * @param {angular.$http} $http the angular http service
   * @param {mapbs/component/citymodel3d/citymodel3dservice/citymodel3dservice} mapbsCitymodel3dService
   * @ngInject
   */
    constructor($scope, $injector, $http, mapbsCitymodel3dService) {
        this.scope = $scope;

        /** @type {string} */
        this.baseURL = `${$injector.get('baseUrl')}`;

        this.http = $http;

        /** @type {mapbs/component/citymodel3d/citymodel3dservice/citymodel3dservice} */
        this._citymodel3dService = mapbsCitymodel3dService;

        /** @type {boolean} */
        this.active;

        /** @type {boolean} */
        this.mobile;

        /** @type {boolean} */
        this.stadtmodelactive = false;

        /** @type {boolean} */
        this.schraegluftbilderactive = false;

        /** @type {boolean} */
        this.meshactive = false;

        this.startingMap = '';

        /** @type {ol.Map} */
        this.map;

        /** @type {!Array.<number>} */
        this.scaleValues;

        this.scope.$watch(
            () => this.active,
            (newVal) => {
                if (!newVal) {
                    this.stadtmodelactive = false;
                    this.schraegluftbilderactive = false;
                    this.meshactive = false;
                }
            }
        );
    }

    isToolActive() {
        return (
            this.stadtmodelactive || this.schraegluftbilderactive || this.meshactive
        );
    }

    openUrlWithMapCenter() {
        const coord = olProj.transform(
            /** @type {Array<number>} */ (this.map.getView().getCenter()),
            'EPSG:2056',
            'EPSG:4326'
        );

        this._citymodel3dService
      .getUrl(coord[0], coord[1], this.scaleValues, this.startingMap)
      .then((url) => {
          window.location = url;
      });
    }

    activate(viewertype) {
        if (viewertype === 'stadtmodel') {
            this.stadtmodelactive = !this.stadtmodelactive;
            if (this.stadtmodelactive) {
                this.schraegluftbilderactive = false;
                this.meshactive = false;
                this.startingMap = '';
                this.http.get(`${this.baseURL}logging?topic=MapBS3D&action=stadtmodel`);
            }
        }
        if (viewertype === 'schraegluftbilder') {
            this.schraegluftbilderactive = !this.schraegluftbilderactive;
            if (this.schraegluftbilderactive) {
                this.stadtmodelactive = false;
                this.meshactive = false;
                this.startingMap = '&state=oblique';
                this.http.get(
                    `${this.baseURL}logging?topic=MapBS3D&action=schraegluftbilder`
                );
            }
        }
        if (viewertype === 'mesh') {
            this.meshactive = !this.meshactive;
            if (this.meshactive) {
                this.schraegluftbilderactive = false;
                this.stadtmodelactive = false;
                this.startingMap = '&layers=3D-Luftbilder';
                this.http.get(`${this.baseURL}logging?topic=MapBS3D&action=mesh`);
            }
        }

        if (this.mobile) {
            // Open URL now
            this.openUrlWithMapCenter();
        }
    }
}

moduleCitymodelpanel.controller('MapbsCityModelController', CityModelController);

export default moduleCitymodelpanel;
